import { IHocKyDangKy } from "../../../model/respone/category/IHocKyDangKy";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHocKyDangKyActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IHocKyDangKy[],
  LOAD_ERRR: "",
};
export const eHocKyDangKyActionIds = generateActionTypeIds(
  eHocKyDangKyActionsObj,
  "HOC_KY_DANG_KY"
);
export type IHocKyDangKyActionTypes = IGenericActionType<
  typeof eHocKyDangKyActionsObj,
  "HOC_KY_DANG_KY"
>;
